/**
 * Whether one held permission grants the required one. Same rules as the backend's
 * PermissionMatcher (LIX-1777): a held `a.*` grants `a`, `a.b.*` and `a.b.c`; a held `a.b.*`
 * grants `a.b.c` but not `a.*` or `a.x.*`; names without `.*` only match themselves.
 * Both sides are tested against permission-wildcard-vectors.json.
 */
export function permissionImplies(held, required) {
  if (!held || !required) return false;
  if (held === required) return true;
  if (!held.endsWith('.*')) return false;

  const prefix = held.slice(0, -1); // 'settings.*' => 'settings.'

  return required === prefix.slice(0, -1) || required.startsWith(prefix);
}

export default function hasPermissionTo(permission, permissions) {
  return (permissions || []).some(held => permissionImplies(held, permission));
}

/**
 * Whether the user holds the permission or anything within it, e.g. any `employee_management.…`
 * for `employee_management.*`. For menus ("may see this area"), like the backend's
 * Authorizer::allowsAnyWithin; buttons and actions use hasPermissionTo.
 */
export function hasAnyPermissionWithin(permission, permissions) {
  if (hasPermissionTo(permission, permissions)) return true;
  if (!permission || !permission.endsWith('.*')) return false;

  const prefix = permission.slice(0, -1); // 'settings.*' => 'settings.'

  return (permissions || []).some(held => held.startsWith(prefix));
}
